import {
  MedicationStockReason,
  MediaAttachment,
  AdministrationStatus
} from '../types'
import StockCount from '../iconsV2/StockCount'
import Disposal from '../iconsV2/Disposal'
import AddStock from '../iconsV2/AddStock'
import Administered from '../iconsV2/Administered'
import Comment from '../iconsV2/Comment'
import { getAdministrationStatusDisplay } from './administrationUtils'

export const getActionTitle = (
  reason: MedicationStockReason,
  t: (key: string) => string,
  administrationStatus: AdministrationStatus | undefined
): string => {
  switch (reason) {
    case MedicationStockReason.INITIAL_STOCK:
      return t('INITIAL_STOCK')
    case MedicationStockReason.STOCK_COUNT:
    case MedicationStockReason.RECONCILIATION:
      return t('STOCK_CHECK')
    case MedicationStockReason.DISPOSAL:
      return t('DISPOSAL')
    case MedicationStockReason.RESTOCK:
      return t('ADD_STOCK')
    case MedicationStockReason.MED_ADMIN:
      return administrationStatus ? t(administrationStatus) : t('ADMINISTERED')
    default:
      return reason.replace(/_/g, ' ')
  }
}

export const getActionSubtitle = (
  reason: MedicationStockReason,
  quantityChange: number,
  unit: string,
  notes?: string | string[]
): string | undefined => {
  switch (reason) {
    case MedicationStockReason.STOCK_COUNT:
    case MedicationStockReason.RECONCILIATION:
    case MedicationStockReason.INITIAL_STOCK:
      return undefined
    case MedicationStockReason.NOT_ADMINISTERED:
      if (Array.isArray(notes)) {
        return notes.join(', ')
      }
      return notes || ''
    case MedicationStockReason.DISPOSAL:
    case MedicationStockReason.RESTOCK:
    case MedicationStockReason.MED_ADMIN:
      const quantity = Math.abs(quantityChange || 0)
      return `${quantity} ${unit}`
    default:
      return undefined
  }
}

export const getActionIcon = (
  type: MedicationStockReason,
  administrationStatus?: AdministrationStatus
) => {
  switch (type) {
    case MedicationStockReason.STOCK_COUNT:
    case MedicationStockReason.RECONCILIATION:
    case MedicationStockReason.INITIAL_STOCK:
      return <StockCount />
    case MedicationStockReason.DISPOSAL:
      return <Disposal />
    case MedicationStockReason.RESTOCK:
      return <AddStock />
    case MedicationStockReason.MED_ADMIN:
      return administrationStatus ? ( 
        getAdministrationStatusDisplay(administrationStatus).display
      ) : (
        <Administered />
      )
    case MedicationStockReason.NOT_ADMINISTERED:
      return <Comment />
    default:
      return <StockCount />
  }
}

export const convertMediaAttachmentsToFileList = (
  mediaAttachments: MediaAttachment[],
  recordId: string
): any[] => {
  return mediaAttachments.map((attachment, i) => ({
    uid: attachment._id || `${recordId}-${i}`,
    name: attachment.key.split('/').pop() || `file-${i}`,
    status: 'done' as const,
    url: attachment.url,
    thumbUrl: attachment.url
  }))
}
